import { AlertTriangle } from 'lucide-react';

const DESCRIPTION = 'Imported history may not establish the cost basis of earlier executions.';

export function HistoricalPnlCaveat() {
  return (
    <span className="inline-flex items-center gap-1 text-xs text-warn" title={DESCRIPTION}>
      <AlertTriangle className="h-3.5 w-3.5" aria-hidden="true" />
      <span>Lifetime P&amp;L unverified</span>
      <span className="sr-only">{DESCRIPTION}</span>
    </span>
  );
}
